module.exports = __webpack_public_path__ + "img/England.99676a11.svg";